import { Component, Input } from '@angular/core';
import { ISaleOfferResponse } from 'src/app/_core/interfaces/ICRMIntegration';

@Component({
  selector: 'new-request-dialog',
  templateUrl: './new-request.component.html'
})
export class NewRequestDialogComponent {

  @Input() dialogOpened: boolean;
  @Input() offerResponse: ISaleOfferResponse;

  get currLng(): string {
		return window.document.documentElement.lang;
	}

  constructor() { }

  newRequest() {
    window.location.href = window.location.href;
  }

  closeDialog() {
    this.dialogOpened = false;
  }
}
